import { render, staticRenderFns } from "./skillScoreRadioWrapper.vue?vue&type=template&id=1fa97777&"
import script from "./skillScoreRadioWrapper.vue?vue&type=script&lang=js&"
export * from "./skillScoreRadioWrapper.vue?vue&type=script&lang=js&"
import style0 from "./skillScoreRadioWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports